import { useNavigate, useSearchParams } from "react-router-dom";
import React, { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import {
  Button,
  createTheme,
  getDesignTokens,
  Grid,
  Paper,
  ThemeProvider,
  Typography,
} from "@platform/style";

import DXLogo from "../../../static/logo.svg";
import { useAlternateLayout } from "../../../utils/useAlternateLayout";

export const IceLogin = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const theme = createTheme(getDesignTokens("light"));
  const [searchParams] = useSearchParams();
  const useAlternate = useAlternateLayout();

  useEffect(() => {
    const companyId = searchParams.get("company");
    const groupId = searchParams.get("groupId");

    if (!auth.isLoading && auth.isAuthenticated) {
      navigate("/");
    } else if (
      !auth.isLoading &&
      !auth.isAuthenticated &&
      (companyId !== null || groupId !== null)
    ) {
      handleLogin(companyId, groupId);
    }
  });

  function handleLogin(companyId: string | null, groupId: string | null) {
    let extraParams: Record<string, string | number | boolean> | undefined = undefined;

    if (companyId || groupId) {
      extraParams = {};

      if (companyId) {
        extraParams["company"] = companyId;
      }
      if (groupId) {
        extraParams["groupId"] = groupId;
      }
    }

    auth
      .clearStaleState()
      .then(() => auth.signinRedirect(extraParams ? { extraQueryParams: extraParams } : undefined));
  }

  return (
    <ThemeProvider theme={theme}>
      <Paper
        elevation={0}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "15%",
          backgroundColor: "background.default",
        }}
      >
        {!auth.isLoading && !auth.isAuthenticated ? (
          <Paper elevation={2} sx={{ width: 398 }}>
            <Grid
              container
              direction="column"
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid item sx={{ paddingTop: "24px", paddingBottom: "12px" }}>
                <img src={DXLogo} alt="MSP® DX Logo" style={{ height: "32px", width: "142px" }} />
              </Grid>
              <Grid item>
                <Typography variant={"body2"}>MSP® Digital Experience</Typography>
              </Grid>
              <Grid item sx={{ paddingTop: "24px", paddingBottom: "24px" }}>
                <Button
                  variant={useAlternate ? undefined : "contained"}
                  onClick={() => handleLogin(null, null)}
                  sx={{ width: "314px" }}
                  disableRipple
                >
                  SIGN IN
                </Button>
              </Grid>
            </Grid>
          </Paper>
        ) : (
          <Typography variant={"body1"}>Loading...</Typography>
        )}
      </Paper>
    </ThemeProvider>
  );
};
